import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../../requestOptions';
import type { CategoryPlanRun, CategoryPlanRunStatus } from './types';

// The organization is taken from the X-Astur-Organization header (added by channelApi), never a
// query param — the backend scopes every query to it — so it is intentionally not a filter here.
export type CategoryPlanRunsFilter = Readonly<{
  destination_channel_name?: string;
  status?: CategoryPlanRunStatus;
  limit?: number;
}>;

export type CategoryPlanRunsData = Readonly<{ runs: CategoryPlanRun[] }>;

type CategoryPlanRunsResponse = Readonly<{ runs: CategoryPlanRun[] }>;

export async function getCategoryPlanRuns(
  scope: RequestScope,
  args: { filter?: CategoryPlanRunsFilter } = {},
  options: ReadRequestOptions
): Promise<ChannelApiResponse<CategoryPlanRunsData>> {
  try {
    const res = await scopedChannelApi(scope).get<CategoryPlanRunsResponse>('atts/category-plan/runs', {
      ...options,
      headers: buildAsturHeaders(),
      params: args.filter,
    });

    const runs = res.data?.runs;
    if (!Array.isArray(runs)) {
      throw new Error('Invalid category plan runs response: missing runs[]');
    }

    return { data: { runs }, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
